import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  partnersEventsApi,
  partnersEventsApiKeys,
} from '@/api/routes/partners/partners.events.api';

export type PartnerEventAction = 'submit' | 'cancel';

/**
 * Send to review or cancel. The API answer (e.g. 422 "Não foi possível localizar o endereço")
 * goes to the global snackbar; the event comes back with its new status.
 */
export const usePartnersEventAction = (action: PartnerEventAction) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => partnersEventsApi[action](id).then((res) => res.data.event),
    onSuccess: (event) => {
      queryClient.setQueryData(partnersEventsApiKeys.detail(event.id), event);
      return queryClient.invalidateQueries({ queryKey: partnersEventsApiKeys.all });
    },
  });
};
